(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eco-footer"]) return;
  try {
    
  if (!customElements.get('iu-cookie-label')) {
    customElements.define('iu-cookie-label', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || !/^it(?:-|$)/i.test(document.documentElement.lang)) return;
        const label = this.dataset.closeLabel;
        if (!label) return;
        const selector = '#shopify-pc__prefs__header-close';
        const translate = (node) => {
          if (!(node instanceof Element)) return;
          const buttons = node.matches(selector) ? [node] : node.querySelectorAll(selector);
          buttons.forEach((button) => {
            if (button.tagName === 'BUTTON' && button.getAttribute('aria-label') === 'Close dialog') {
              button.setAttribute('aria-label', label);
            }
          });
        };
        this.observer = new MutationObserver((records) => {
          records.forEach((record) => {
            if (record.type === 'attributes') translate(record.target);
            else record.addedNodes.forEach(translate);
          });
        });
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
        translate(document.body);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eco-header"]) return;
  try {
    
function bindIngroUnicoCartCount(){
  if(window.iuCartCountBound)return;
  window.iuCartCountBound=true;
  let revision=0;
  const refreshCount=async()=>{
    const current=++revision;
    const route=window.routes&&window.routes.cart_url;
    if(typeof route!=='string'||!route.startsWith('/')||route.startsWith('//'))return;
    const counters=[...document.querySelectorAll('.eco-cart-link b')].map(element=>({element,value:element.textContent}));
    if(!counters.length)return;
    try{
      const response=await fetch(route+'.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return;
      const cart=await response.json();
      if(current!==revision||!Number.isSafeInteger(cart.item_count)||cart.item_count<0)return;
      counters.forEach(({element,value})=>{if(element.textContent===value)element.textContent=String(cart.item_count);});
    }catch{}
  };
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,refreshCount);
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshCount();});
  window.addEventListener('pagehide',()=>{revision++;});
  refreshCount();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindIngroUnicoCartCount,{once:true});else bindIngroUnicoCartCount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eco-home"] && !Shopify.designMode) return;
  try {
    
function ecoMenuLayout(){document.querySelectorAll('.eco-departments-shell').forEach(el=>{el.open=window.innerWidth>749;});}ecoMenuLayout();document.addEventListener('shopify:section:load',ecoMenuLayout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iu-lighting"]) return;
  try {
    
(function(){const p=new URLSearchParams(location.search);if(p.get('utm_source')!=='facebook'||p.get('utm_medium')!=='paid_social'||p.get('utm_campaign')!=='igu_luce_campania_14d')return;const c=p.get('utm_content');if(!['video_a','image_b'].includes(c))return;const q=new URLSearchParams({utm_source:'facebook',utm_medium:'paid_social',utm_campaign:'igu_luce_campania_14d',utm_content:c});const to='/?'+q.toString();document.querySelectorAll('[data-iu-register]').forEach(a=>{a.href='/customer_authentication/login?return_to='+encodeURIComponent(to)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iu-order-desk"] && !Shopify.designMode) return;
  try {
    
const MAX_ROWS=500;
const MAX_QUANTITY=999999;
class ImportError extends Error {}
function integer(value){
  if(!/^[1-9]\d*$/.test(String(value))||!Number.isSafeInteger(Number(value))||Number(value)>MAX_QUANTITY)throw new ImportError('La quantità deve essere un intero positivo non superiore a 999999.');
  return Number(value);
}
function skuValue(value){
  const sku=String(value).trim();
  if(!sku||sku.length>128||/[\x00-\x1f\x7f]/.test(sku)||/^[=+@-]/.test(sku))throw new ImportError('SKU vuoto, formula o caratteri non consentiti.');
  return sku;
}
function consolidateLines(lines){
  if(!Array.isArray(lines)||!lines.length||lines.length>MAX_ROWS)throw new ImportError('Inserisci da 1 a 500 righe.');
  const map=new Map();
  for(const line of lines){const sku=skuValue(line.sku),quantity=integer(line.quantity);map.set(sku,integer((map.get(sku)||0)+quantity));}
  return [...map].map(([sku,quantity])=>({sku,quantity}));
}
function parseOrderText(input){
  if(typeof input!=='string'||input.length>1024*1024)throw new ImportError('File non valido o troppo grande (massimo 1 MB).');
  let text=input.replace(/^\uFEFF/,'').replace(/\r\n?/g,'\n');
  let declared=text.match(/^sep=([;,\t])\n/i),delimiter=declared?.[1];
  if(declared)text=text.slice(declared[0].length);
  if(!delimiter){
    let quote=false,counts={',':0,';':0,'\t':0};
    for(let i=0;i<text.length;i++){const c=text[i];if(c==='"'){if(quote&&text[i+1]==='"'){i++;continue;}quote=!quote;}else if(!quote){if(c==='\n')break;if(c in counts)counts[c]++;}}
    const choices=Object.entries(counts).filter(([,n])=>n>0);
    if(choices.length!==1)throw new ImportError('Usa due colonne separate da virgola, punto e virgola o tabulazione.');
    delimiter=choices[0][0];
  }
  const rows=[];let row=[],cell='',quoted=false,closed=false;
  function emitCell(){row.push(cell);cell='';closed=false;}
  function emitRow(){emitCell();if(row.some(v=>v.trim()))rows.push(row);row=[];if(rows.length>MAX_ROWS+1)throw new ImportError('Massimo 500 righe.');}
  for(let i=0;i<text.length;i++){
    const c=text[i];
    if(quoted){if(c==='"'){if(text[i+1]==='"'){cell+='"';i++;}else{quoted=false;closed=true;}}else cell+=c;continue;}
    if(c===delimiter){emitCell();continue;}
    if(c==='\n'){emitRow();continue;}
    if(closed){if(c===' ')continue;throw new ImportError('Carattere inatteso dopo una cella tra virgolette.');}
    if(c==='"'){if(cell.length)throw new ImportError('Virgolette non valide.');quoted=true;}else cell+=c;
  }
  if(quoted)throw new ImportError('Virgolette non chiuse.');
  if(cell.length||row.length||closed)emitRow();
  const header=rows[0]?.map(v=>v.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,''));
  if(header?.[0]==='sku'&&['quantity','quantita','qty'].includes(header[1])&&header.length===2)rows.shift();
  return consolidateLines(rows.map((r,i)=>{if(r.length!==2)throw new ImportError(`Riga ${i+1}: servono esattamente SKU e quantità.`);return{sku:r[0],quantity:r[1].trim()};}));
}
function reviewOrderLines(lines,catalog,{existingQuantities={}}={}){
  const entries=consolidateLines(lines),resolved=[],issues=[];
  for(const line of entries){
    const matches=catalog.filter(v=>v.sku===line.sku);
    if(matches.length!==1){issues.push({sku:line.sku,code:matches.length?'AMBIGUOUS_SKU':'NOT_IN_CATALOG'});continue;}
    const variant=matches[0],rule=variant.quantityRule;
    if(!rule||!Number.isSafeInteger(rule.minimum)||!Number.isSafeInteger(rule.increment)||rule.minimum<1||rule.increment<1||rule.minimum%rule.increment!==0){issues.push({sku:line.sku,code:'RULE_UNAVAILABLE'});continue;}
    const existing=existingQuantities[variant.id]??0;
    if(!Number.isSafeInteger(existing)||existing<0)throw new ImportError('Quantità del carrello non valida.');
    const finalQuantity=existing+line.quantity;
    if(!Number.isSafeInteger(finalQuantity)||finalQuantity>MAX_QUANTITY){issues.push({sku:line.sku,code:'QUANTITY_OVERFLOW'});continue;}
    if(finalQuantity<rule.minimum||finalQuantity%rule.increment!==0){issues.push({sku:line.sku,code:'QUANTITY_RULE',minimum:rule.minimum,increment:rule.increment,requested:finalQuantity});continue;}
    if(rule.maximum!=null&&(!Number.isSafeInteger(rule.maximum)||rule.maximum<rule.minimum||rule.maximum%rule.increment!==0)){issues.push({sku:line.sku,code:'RULE_UNAVAILABLE'});continue;}
    if(rule.maximum!=null&&finalQuantity>rule.maximum){issues.push({sku:line.sku,code:'MAXIMUM'});continue;}
    if(variant.available!==true||(variant.availableQuantity!=null&&(!Number.isSafeInteger(variant.availableQuantity)||variant.availableQuantity<finalQuantity))){issues.push({sku:line.sku,code:'UNAVAILABLE'});continue;}
    resolved.push({sku:line.sku,variantId:variant.id,quantity:line.quantity,finalQuantity});
  }
  return{ready:issues.length===0,lines:issues.length?[]:resolved,issues};
}
function scopeKey(scope){
  if(!scope||!scope.shop||!scope.customerId||!scope.companyLocationId)throw new ImportError('Contesto cliente e sede aziendale obbligatorio.');
  return JSON.stringify([scope.shop,scope.customerId,scope.companyLocationId]);
}
function makeSavedList({name,lines},trustedScope){
  if(typeof name!=='string'||!name.trim()||name.trim().length>80)throw new ImportError('Nome lista obbligatorio, massimo 80 caratteri.');
  return{version:1,owner:scopeKey(trustedScope),name:name.trim(),lines:consolidateLines(lines)};
}
function readSavedList(record,trustedScope){
  if(record?.version!==1||record.owner!==scopeKey(trustedScope))throw new ImportError('Lista non disponibile per questo cliente e questa sede.');
  return consolidateLines(record.lines);
}
function orderText(lines){return 'SKU;Quantità\n'+consolidateLines(lines).map(l=>'"'+l.sku.replaceAll('"','""')+'";'+l.quantity).join('\n')+'\n';}

async function collectCatalogPages(readPage,scope,currency){
  const variants=[],seenVariants=new Set(),seenProducts=new Set();
  let pages=1,total;
  for(let page=1;page<=pages;page++){
    const batch=await readPage(page);
    if(!batch||batch.scope!==scope||batch.currency!==currency)throw new Error('SESSION_CHANGED');
    if(!Number.isSafeInteger(batch.total)||batch.total<0||batch.total>25000||batch.page!==page||batch.pages!==Math.max(1,Math.ceil(batch.total/250))||batch.incomplete)throw new Error('CATALOG_INCOMPLETE');
    if(page===1){pages=batch.pages;total=batch.total;}
    if(batch.total!==total||batch.pages!==pages||batch.products.length!==Math.min(250,total-(page-1)*250))throw new Error('CATALOG_CHANGED');
    if(batch.variants.length<batch.products.length)throw new Error('CATALOG_INCOMPLETE');
    for(const id of batch.products){if(!/^\d+$/.test(id)||seenProducts.has(id))throw new Error('CATALOG_CHANGED');seenProducts.add(id);}
    for(const variant of batch.variants){if(!/^\d+$/.test(variant.id)||seenVariants.has(variant.id))throw new Error('CATALOG_CHANGED');seenVariants.add(variant.id);variants.push(variant);}
    if(variants.length>25000)throw new Error('CATALOG_INCOMPLETE');
  }
  const probe=await readPage(1);
  if(!probe||probe.scope!==scope||probe.currency!==currency)throw new Error('SESSION_CHANGED');
  if(probe.total!==total||probe.pages!==pages||probe.incomplete||probe.products.some(id=>!seenProducts.has(id)))throw new Error('CATALOG_CHANGED');
  return variants;
}

class IngroUnicoOrderDesk extends HTMLElement {
  connectedCallback(){
    if(this.initialized)return;
    this.initialized=true;
    this.dataset.root=this.dataset.root.replace(/\/?$/,'/');
    this.messages=this.querySelector('[data-messages]').dataset;
    this.catalogMessages=this.querySelector('[data-catalog-messages]').dataset;
    this.scope=this.dataset.scope;
    this.storageKey='ingrounico-order-lists-v1:'+this.scope;
    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-action]');
      if(button)this.act(button.dataset.action);
    });
    this.querySelector('[data-search]').addEventListener('input',event=>{
      const term=event.target.value.trim().toLocaleLowerCase();
      this.querySelectorAll('[data-variant]').forEach(row=>row.hidden=!row.textContent.toLocaleLowerCase().includes(term));
    });
    this.querySelector('[data-search]').addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();this.act('search');}});
    this.querySelector('[data-file]').addEventListener('change',async event=>{
      const file=event.target.files[0];if(!file)return;
      try{
        if(file.size>1024*1024||!/\.(csv|tsv)$/i.test(file.name))throw new Error();
        this.querySelector('[data-import]').value=await file.text();
        this.status(this.messages.reviewed);
      }catch{this.status(this.messages.invalid,true);}
    });
    this.refreshLists();
  }
  status(message,error=false){
    const box=this.querySelector('[data-status]');box.textContent=message;box.classList.toggle('iu-error',error);
  }
  selected(){
    const lines=[];
    this.querySelectorAll('[data-variant]').forEach(row=>{
      const value=row.querySelector('[data-quantity]').value.trim();
      if(value!==''&&value!=='0')lines.push({sku:row.dataset.sku,quantity:value});
    });
    if(!lines.length)throw new Error(this.messages.noSelection);
    return consolidateLines(lines);
  }
  catalog(root=this){
    return [...root.querySelectorAll('[data-variant]')].map(row=>({
      id:row.dataset.id,sku:row.dataset.sku,title:row.dataset.title||row.querySelector('td')?.textContent.trim()||row.dataset.sku,url:row.dataset.url||row.querySelector('a')?.getAttribute('href'),price:row.dataset.price||'',available:row.dataset.available==='true',
      availableQuantity:row.dataset.stock===''?null:Number(row.dataset.stock),
      quantityRule:{minimum:Number(row.dataset.min),increment:Number(row.dataset.step),maximum:row.dataset.max===''?null:Number(row.dataset.max)}
    }));
  }
  async freshCatalog(){
    try{return await collectCatalogPages(async page=>{
      if(!this.isConnected)throw new Error('SESSION_CHANGED');
      const url=new URL(this.dataset.root+'collections/all',location.origin);
      url.searchParams.set('section_id','iu-catalog-index');url.searchParams.set('page',page);url.searchParams.set('sort_by','title-ascending');url.searchParams.set('_iu',Date.now());
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
      if(!response.ok)throw new Error('CATALOG_INCOMPLETE');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html'),index=doc.querySelector('[data-iu-index]');
      if(!index||index.dataset.scope!==this.scope)throw new Error('SESSION_CHANGED');
      return{scope:index.dataset.scope,currency:index.dataset.currency,page:Number(index.dataset.page),pages:Math.max(1,Number(index.dataset.pages)),total:Number(index.dataset.total),incomplete:!!index.querySelector('[data-index-incomplete]'),products:[...index.querySelectorAll('[data-index-product]')].map(node=>node.dataset.indexProduct),variants:this.catalog(index)};
    },this.scope,this.dataset.currency);}catch(error){throw new Error(error.message==='SESSION_CHANGED'?this.messages.session:this.catalogMessages.incomplete);}
  }
  async cart(){
    const response=await fetch(this.dataset.root+'cart.js',{credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error(this.messages.uncertain);
    return response.json();
  }
  quantities(cart){
    const result={};for(const item of cart.items)result[String(item.variant_id)]=(result[String(item.variant_id)]||0)+item.quantity;return result;
  }
  review(lines,catalog,cart){
    const result=reviewOrderLines(lines,catalog,{existingQuantities:this.quantities(cart)});
    this.querySelectorAll('[data-quantity]').forEach(input=>input.removeAttribute('aria-invalid'));
    if(!result.ready){
      for(const issue of result.issues){
        const row=[...this.querySelectorAll('[data-variant]')].find(row=>row.dataset.sku===issue.sku);
        row?.querySelector('[data-quantity]').setAttribute('aria-invalid','true');
      }
      throw new Error(this.messages.rules+'\n'+result.issues.map(issue=>issue.sku+(issue.minimum?' — min '+issue.minimum+', +'+issue.increment:'')).join('\n'));
    }
    return result;
  }
  ensureRows(lines,catalog){
    const wanted=new Set(lines.map(line=>line.sku)),present=new Set([...this.querySelectorAll('[data-variant]')].map(row=>row.dataset.id));
    for(const variant of catalog){
      if(!wanted.has(variant.sku)||present.has(variant.id))continue;
      const row=document.createElement('tr');row.dataset.variant='';
      Object.assign(row.dataset,{id:variant.id,sku:variant.sku,title:variant.title,url:variant.url,min:String(variant.quantityRule.minimum),step:String(variant.quantityRule.increment),max:variant.quantityRule.maximum??'',stock:variant.availableQuantity??'',available:String(variant.available)});
      const title=document.createElement('td'),link=document.createElement('a'),url=new URL(variant.url,location.origin);
      if(url.origin!==location.origin||!url.pathname.startsWith(this.dataset.root+'products/'))throw new Error(this.catalogMessages.incomplete);
      link.href=url.href;link.textContent=variant.title;title.append(link);
      const sku=document.createElement('td');sku.textContent=variant.sku;
      const price=document.createElement('td');price.textContent=variant.price;
      const rule=document.createElement('td');rule.textContent='Min. '+variant.quantityRule.minimum+' · +'+variant.quantityRule.increment+(variant.quantityRule.maximum?' · Max. '+variant.quantityRule.maximum:'');
      const quantity=document.createElement('td'),input=document.createElement('input');input.type='number';input.inputMode='numeric';input.min='0';input.step=String(variant.quantityRule.increment);input.value='0';input.dataset.quantity='';input.disabled=!variant.available;input.setAttribute('aria-label',this.catalogMessages.quantity+' — '+variant.sku);quantity.append(input);
      if(!variant.available){const unavailable=document.createElement('small');unavailable.textContent=this.catalogMessages.unavailable;title.append(unavailable);}
      row.append(title,sku,price,rule,quantity);this.querySelector('[data-resolved-rows]').append(row);present.add(variant.id);
    }
  }
  fill(lines,catalog=[]){
    this.ensureRows(lines,catalog);
    const bySku=new Map(lines.map(line=>[line.sku,line.quantity]));
    this.querySelectorAll('[data-variant]').forEach(row=>row.querySelector('[data-quantity]').value=bySku.get(row.dataset.sku)||0);
  }
  records(){
    const value=JSON.parse(localStorage.getItem(this.storageKey)||'[]');
    if(!Array.isArray(value)||value.length>10)throw new Error();
    return value.filter(record=>record.version===1&&record.owner===this.scope&&typeof record.name==='string'&&record.name.length<=80);
  }
  refreshLists(){
    const select=this.querySelector('[data-lists]');
    select.replaceChildren(new Option(this.messages.choose,''));
    try{this.records().forEach((record,index)=>select.add(new Option(record.name,String(index))));}
    catch{this.status(this.messages.storage,true);}
  }
  async act(action){
    if(this.busy)return;
    this.busy=true;this.querySelectorAll('button').forEach(button=>button.disabled=true);
    const controls=[...this.querySelectorAll('input,select,textarea')].map(input=>[input,input.disabled]);controls.forEach(([input])=>input.disabled=true);
    let postAttempted=false;
    try{
      if(action==='reset'){this.fill([]);this.status('');return;}
      if(action==='search'){
        const term=this.querySelector('[data-search]').value.trim().toLocaleLowerCase();
        if(!term){this.querySelectorAll('[data-variant]').forEach(row=>row.hidden=false);this.status('');return;}
        this.status(this.messages.busy);
        const catalog=await this.freshCatalog(),matches=catalog.filter(variant=>(variant.sku+' '+variant.title).toLocaleLowerCase().includes(term));
        this.ensureRows(matches,catalog);this.querySelectorAll('[data-variant]').forEach(row=>row.hidden=!(row.dataset.sku+' '+(row.dataset.title||row.textContent)).toLocaleLowerCase().includes(term));
        this.status(this.catalogMessages.found.replace('[count]',String(matches.length)));return;
      }
      if(action==='delete'){
        const index=this.querySelector('[data-lists]').value;if(index==='')throw new Error(this.messages.choose);
        const records=this.records();records.splice(Number(index),1);localStorage.setItem(this.storageKey,JSON.stringify(records));this.refreshLists();this.status(this.messages.saved);return;
      }
      let lines;
      if(action==='import')lines=parseOrderText(this.querySelector('[data-import]').value);
      else if(action==='load'){
        const index=this.querySelector('[data-lists]').value;if(index==='')throw new Error(this.messages.choose);
        lines=consolidateLines(this.records()[Number(index)].lines);
      }else lines=this.selected();
      if(action==='export'){
        const blob=new Blob(['\uFEFF'+orderText(lines)],{type:'text/csv;charset=utf-8;'});
        const url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download='ingrounico-riordino.csv';link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);return;
      }
      if(action==='save'){
        const name=this.querySelector('[data-list-name]').value.trim();if(!name||name.length>80)throw new Error(this.messages.invalid);
        const records=this.records();if(records.length>=10)throw new Error(this.messages.storage);
        records.push({version:1,owner:this.scope,name,lines});localStorage.setItem(this.storageKey,JSON.stringify(records));this.refreshLists();this.status(this.messages.saved);return;
      }
      this.status(this.messages.busy);
      const catalog=await this.freshCatalog(),before=await this.cart();
      const review=this.review(lines,catalog,before);
      if(action==='import'||action==='load'){this.fill(lines,catalog);this.querySelector('[data-search]').value='';this.querySelectorAll('[data-variant]').forEach(row=>row.hidden=false);this.status(this.messages.reviewed);return;}
      if(action==='add'){
        postAttempted=true;
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:review.lines.map(line=>({id:line.variantId,quantity:line.quantity}))})});
        const body=await response.json();
        const afterCart=await this.cart();
        const after=this.quantities(afterCart);
        const exact=review.lines.every(line=>after[line.variantId]===line.finalQuantity);
        if(!response.ok||!exact)throw new Error(this.messages.uncertain+(typeof body.description==='string'?'\n'+body.description:''));
        this.fill([]);this.status(this.messages.added);
        const count=document.querySelector('.eco-cart-link b');
        if(count)count.textContent=String(afterCart.item_count);
      }
    }catch(error){
      this.status(postAttempted?this.messages.uncertain+(error.message?'\n'+error.message:''):error instanceof ImportError?this.messages.invalid:error.message||this.messages.invalid,true);
    }finally{this.busy=false;this.querySelectorAll('button').forEach(button=>button.disabled=false);controls.forEach(([input,disabled])=>input.disabled=disabled);}
  }
}
if(!customElements.get('iu-order-desk'))customElements.define('iu-order-desk',IngroUnicoOrderDesk);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iu-phone-model-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('iu-phone-model-navigation')) {
    customElements.define('iu-phone-model-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('[data-phone-search]').hidden = false;
        const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, '');
        this.querySelector('[data-phone-input]').addEventListener('input', event => {
          const query = normalize(event.target.value);
          let found = 0;
          this.querySelectorAll('[data-phone-brand]').forEach(brand => {
            let matches = 0;
            brand.querySelectorAll('[data-phone-model]').forEach(item => {
              item.hidden = !normalize(item.dataset.search).includes(query);
              if (!item.hidden) matches++;
            });
            brand.hidden = matches === 0;
            brand.open = Boolean(query) && matches > 0;
            found += matches;
          });
          this.querySelectorAll('[data-phone-kind]').forEach(kind => {
            kind.hidden = !Array.from(kind.querySelectorAll('[data-phone-brand]')).some(brand => !brand.hidden);
          });
          this.querySelector('[data-phone-empty]').hidden = found > 0;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
function bindIngroUnicoCartHistory(){
  if(window.iuCartHistoryBound)return;
  window.iuCartHistoryBound=true;
  let reloading=false;
  const refreshPage=()=>{
    if(reloading||!document.querySelector('cart-items'))return;
    reloading=true;
    window.location.reload();
  };
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshPage();});
  const navigation=window.performance?.getEntriesByType?.('navigation')?.[0];
  if(navigation?.type==='back_forward')refreshPage();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindIngroUnicoCartHistory,{once:true});else bindIngroUnicoCartHistory();

  } catch(e) { console.error(e); }
})();
})();
